import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing tangent functions.
 * Focus: Tangent curve with vertical asymptotes.
 */
export const TANGENT_PRESET: GraphpadWidgetConfig = {
  id: 'tangent',
  type: 'graphpad',
  params: {
    f: {
      type: 'tangent-fn',
      params: { a: 1, b: 1, c: 0, d: 0 },
    },
    'f-translate': {
      type: 'handle',
      params: { of: 'f', behavior: 'translate' },
    },
    'f-asymptotes': {
      type: 'asymptotes',
      params: { of: 'f' },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
    'f-period': {
      type: 'period',
      params: { of: 'f' },
    },
    'f-phaseShift': {
      type: 'phaseShift',
      params: { of: 'f' },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -Math.PI, xEnd: (3 * Math.PI) / 2, yStart: -5, yEnd: 5 },
      grid: { type: 'lines', visible: false },
      axes: {
        custom: [
          {
            id: 'x',
            orientation: 'horizontal',
            position: 0,
            isPrimary: true,

            ticks: {
              ticksDistance: Math.PI / 4,
              labelFormat: 'pi',
            },
          },
          {
            id: 'y',
            orientation: 'vertical',
            position: 0,
            isPrimary: true,

            ticks: { ticksDistance: 1 },
          },
        ],
      },
    },
    elements: {
      'f-period': {
        subparts: {
          arrow: {
            line: {
              label: { text: 'T = {length}', position: 'top', variant: 'secondary' },
            },
          },
        },
      },
      'f-phaseShift': {
        subparts: {
          arrow: {
            line: {
              label: { text: 'c = {length}', position: 'top', variant: 'secondary' },
            },
          },
        },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'a (scale)',
        param: 'f.a',
        range: [-3, 3, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'red',
      },
      {
        id: 'slider-b',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'b (frequency)',
        param: 'f.b',
        range: [0.1, 3, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'indigo',
      },
      {
        id: 'slider-c',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'c (phase)',
        param: 'f.c',
        range: [-Math.PI, Math.PI, 0.1],
        defaultValue: 0,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-d',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'd (y-shift)',
        param: 'f.d',
        range: [-3, 3, 0.1],
        defaultValue: 0,
        editable: true,
        color: 'amber',
      },
    ],
  },
};
